<template>
  <el-tooltip v-bind="tooltip">
    <template #content>
      <slot name="content" />
    </template>
    <span class="p-hint">
      <span class="el-text el-text--body-24 el-text--color-fixed-primary">
        {{ label }}
      </span>
      <el-icon
        class="ml-8"
        name="i-info-circle-small--16"
        color="fixed-light"
        data-test-id="hint.tooltip-toggle"
      />
    </span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'Hint',
  props: {
    label: {
      type: String,
      default: ''
    },
    tooltip: {
      type: Object,
      default: () => ({
        content: '',
        placement: 'right'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.p-hint {
  display: inline-flex;
  align-items: center;
}
</style>
